import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";
import { DropShadowFilter } from "pixi-filters";

export class EarnCoinsContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        const coinIcon = new Sprite(unboardingResources.assets_views_unboarding_coin_icon_png);
        coinIcon.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xff00b8 })];
        this.addChild(coinIcon);
        const earnText = new Text(`EARN`, new ContainerTextStyle());
        earnText.style.fill = ["#fee201", "#ffab19"];
        earnText.angle = -5;
        earnText.skew.x = -0.08;
        earnText.position.set(-2, 225);
        this.addChild(earnText);
        const gameCoinsText = new Text(`GAME COINS`, new ContainerTextStyle());
        gameCoinsText.style.fontSize = 26;
        gameCoinsText.angle = -5;
        gameCoinsText.skew.x = -0.08;
        gameCoinsText.position.set(25, 286);
        this.addChild(gameCoinsText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}